import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__verifyAribOtp = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(transaction_id, order_uuid, otp) {
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = {
            transaction_id: transaction_id,
            order_uuid: order_uuid,
            otp: otp
          };
          _context.n = 1;
          return fetcher(null, true).post('/aarib/otp-verify', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function api__verifyAribOtp(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default api__verifyAribOtp;